/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FeatureResource = {
    id: number;
    /**
     * The name of the feature.
     */
    name: string;
    /**
     * The display name of the feature.
     */
    display_name: string;
    /**
     * The description of the feature.
     */
    description: string;
    /**
     * Whether the feature is available.
     */
    available: boolean;
    /**
     * Whether the feature is enabled for the current user.
     */
    enabled: boolean;
    /**
     * Whether the feature is toggleable.
     */
    toggleable: boolean;
    /**
     * List of URL paths this feature is applicable to.
     */
    showToggleable: Array<string> | null;
    /**
     * The type of toggleable feature.
     */
    toggleableType: FeatureResource.toggleableType | null;
};

export namespace FeatureResource {

    /**
     * The type of toggleable feature.
     */
    export enum toggleableType {
        ALPHA = 'alpha',
        BETA = 'beta',
    }


}

